module.exports = __webpack_public_path__ + "img/telegramIcon.919fbef9.svg";